import { useState } from 'react';

import { useSelector } from 'react-redux';

import classes from './Header.module.css';

import heartIcon from '../../assets/img/heartIcon.svg';
import { scrollClickHandler, getUniqueListBy } from '../../utils/utils';
import PopupModal from '../PopupModal/PopupModal';
const Header = () => {
  const shortlist = useSelector((state) => state.shortlistRed.shortlistedOptions);

  const currentDeal = useSelector((state) => state?.comRed?.currentDeal);
  // shortlist = getUniqueListBy(shortlist, 'optionId');

  const data = useSelector((state) => state.optRed.data);
  const [isModalOpen, setIsmodalOpen] = useState(false);
  const showVideo = (event) => {
    event.preventDefault();
    setIsmodalOpen(true);
  };
  const closeModal = () => {
    setIsmodalOpen(false);
  };

  return (
    <header className={classes.header}>
      <div style={{ marginLeft: '28px' }}>
        <div className={classes.solutions__title}>
          Agile Real Estate Solutions for {currentDeal?.['Client Name']?.[0]}
        </div>
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          marginRight: '64px',
          alignItems: 'center',
        }}
      >
        <div className={classes.imgBlock} onClick={() => scrollClickHandler('shortlist')}>
          <img className={classes.icon} src={heartIcon} alt="heart icon"></img>
          <div className={classes.shortlist__text}>Shortlist ({shortlist.length})</div>
        </div>
        <div className={classes.infolink} onClick={showVideo} title="How to shortlist"></div>
      </div>
      {isModalOpen && <PopupModal hideModal={() => setIsmodalOpen(false)} />}
    </header>
  );
};

export default Header;
